import { jwtDecode } from 'jwt-decode'
import { useEffect, useState } from 'react'
import { useSessionData } from 'hooks/session.hook'

import type { OtpRole, TokenPayload } from 'types/commons/model'
import { OTP_ROLE_PREFIX, OTP_ROLES } from 'utils/constants'
import { useGoToTokenGenerator } from '../token-generator/TokenGenerator.navigator'

export const useTokenType = () => {
  const { user, country, warehouse, logout } = useSessionData()
  const [otpRoles, setOtpRoles] = useState<OtpRole[]>([])
  const tokenGeneratorPage = useGoToTokenGenerator()

  useEffect(() => {
    const token = user.authorization
    const decodedToken = jwtDecode<TokenPayload>(token)

    const optUserRoles = decodedToken.realm_access.roles
      .filter((role) => role.startsWith(OTP_ROLE_PREFIX))
      .map(
        (role) =>
          OTP_ROLES[role] || { id: role, label: role, iconName: 'ic_report' }
      )

    setOtpRoles(optUserRoles)
  }, [user.authorization])

  const onSelectType = (otpType: string) => {
    tokenGeneratorPage.go(otpType)
  }

  return {
    user,
    country,
    warehouse,
    otpRoles,
    actions: { logout, onSelectType }
  }
}
